module.exports = __webpack_public_path__ + "img/TC.415180b6.svg";